import type { Ref } from 'react';
import { useEffect, useRef, useState } from 'react';
import type { ChangeEvent, HTMLAttributes } from 'react';
import { Icon } from './Icon';
import { Menu } from './Menu';
import { cx } from '../lib/cx';

export interface SearchControlProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'onChange' | 'onSubmit' | 'children'> {

  value: string;
  onChange: (value: string) => void;

  placeholder?: string;
  label: string;
}

export function SearchControl(
  { ref, value, onChange, placeholder, label, className, ...rest }: SearchControlProps & { ref?: Ref<HTMLDivElement> },
) {
  const [open, setOpen] = useState(value.length > 0);
  const input = useRef<HTMLInputElement>(null);
  useEffect(() => { if (open) input.current?.focus(); }, [open]);
  return <div ref={ref} className={cx('search-control', open && 'is-open', className)} {...rest}>
    <Menu presentation="pill" retainTrigger panelRole="search" open={open} onOpenChange={setOpen}
      trigger={<Icon name="i-search" />} triggerButtonProps={{ iconOnly: true, isActive: value.length > 0, 'aria-label': label, title: label }}>
      <div className="toolbar-search-field"><input ref={input} className="search-input" type="text"
        aria-label={label} placeholder={placeholder} value={value}
        onChange={(event: ChangeEvent<HTMLInputElement>) => onChange(event.target.value)}
 /></div>
    </Menu>
  </div>;
}
